export default __webpack_public_path__ + "img/jayant kohale.fc9910af.jpg";